export default "__VITE_ASSET__DPoF966k__"